import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const PCCOFMI_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/pccofmi/logo.png",
        alt: "Perspectives Counseling Centers Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 52,
  state: "MI",
  departmentIds: [205, 214, 221, 223],
};
